import React, { useState } from "react";
import { Grid, IconButton, makeStyles, Tooltip, Typography } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { useHistory } from "react-router";
import { useAuthState } from "../../../../../context/auth";
import FieldNavLink from "../../../../elements/FieldNavLink";
import FieldMeta from "../../../../field/FieldMeta";
import { useAnalyticsState } from "../../../../../context/analytics";
import QrCodeDialog from "../../../../elements/QrCodeDialog";

const QrCodeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 11V3h8v8H3Zm2-2h4V5H5v4ZM3 21v-8h8v8H3Zm2-2h4v-4H5v4Zm8-8V3h8v8h-8Zm2-2h4V5h-4v4Zm4 12v-2h2v2h-2Zm-6-6v-2h2v2h-2Zm2 2v-2h2v2h-2Zm-2 2v-2h2v2h-2Zm2 2v-2h2v2h-2Zm2-2v-2h2v2h-2Zm0-4v-2h2v2h-2Zm2 2v-2h2v2h-2Z"/>
  </svg>
);

const AnalyticsHeader = () => {
  const useStyles = makeStyles(({ palette, spacing }) => ({
    root: {
      padding: spacing(4, 2, 3),
      marginTop: spacing(-4),
      backgroundColor: palette.grey[100],
    },
    icon: {
      marginLeft: spacing(1),
      marginRight: spacing(1),
      color: palette.text.disabled,
    },
  }));
  const classes = useStyles();
  const { isAdmin, client } = useAuthState();
  const { field } = useAnalyticsState();
  const history = useHistory();
  const [showQrCode, setShowQrCode] = useState(false);
  const handleClick = ({ id }) => {
    return history.push(`/admin/field/${id}`);
  };

  return (
    <Grid className={classes.root}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
        <Grid item xs={12} md={true}>
          <FieldNavLink fields={client.fields} current={field.id}>
            {isAdmin ? (
              <IconButton
                size="small"
                className={classes.icon}
                onClick={() => handleClick(field)}
              >
                <EditIcon />
              </IconButton>
            ) : null}
            <Typography variant="h1">{field.name}</Typography>
          </FieldNavLink>
        </Grid>
        <Grid item>
          <Tooltip title="Show QR Code">
            <IconButton
              size="small"
              className={classes.icon}
              onClick={() => setShowQrCode(true)}
            >
              <QrCodeIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item>
          <FieldMeta field={field} />
        </Grid>
      </Grid>
      <QrCodeDialog
        open={showQrCode}
        onClose={() => setShowQrCode(false)}
        fieldId={field.id}
        fieldName={field.name}
        farmName={field.farm}
      />
    </Grid>
  );
};

export default AnalyticsHeader;
